import React from 'react';
import styled from 'styled-components';

const StyledCircle = styled.div`
    height: 8px;
    width: 8px;
    border: 2px solid #FFFFFF;
    border-radius: 100px;
    background: ${({filled}) => filled && '#FFFFFF'};
    margin: ${({margin}) => margin && `${margin.top || 0} ${margin.right || 0} ${margin.bottom || 0} ${margin.left || 0} `};
`;

export const Circle = (props) => {
    return <StyledCircle {...props} />
}

const StyledBadge = styled.div`
    height: 9px;
    width: 9px;
    border-radius: 100px;
    background: ${({color}) => color};
    margin-left: 3px;
`
export const Badge = (props) => <StyledBadge {...props} />